<template>
  <v-card class="pa-2">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Gestione Tabelle</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="from_label == false" @click="goBack" class="mr" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-container>
      <TabelleCustomList
        v-if="sezione_attiva == 1"
        @crea_tabella="creaTabella"
        @modificaTabella="goToModificaTabella"
        @elimina_tabella="setTabella"
        :lista_tabelle="lista_tabelle"
        :from_adapter_list="from_adapter_list"
      />
      <TabellaCustom
        v-if="sezione_attiva == 2"
        @click_indietro="clickIndietro"
        @save_table="saveTable"
        :tabella_full="tabella"
        :from_adapter="from_adapter"
        :save_table_snack="save_table_snack"
        :visualizza_dialog_tabella_custom="sezione_attiva == 2"
      />
    </v-container>
    <SnackbarQV ref="SnackbarQV" />

     <!-- Overlay -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </v-card>
</template>
<script>
import TabellaCustom from "@/components/TABELLA_CUSTOM/TabellaCustom.vue";
import TabelleCustomList from "@/components/TABELLA_CUSTOM/TabelleCustomList.vue";
import TabellaCustomClass from "@/classes/TabellaCustomClass.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "TabellaCustomAdapter",
  components: {
    TabellaCustom,
    TabelleCustomList,
    SnackbarQV,
  },
  props: {
       from_label: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      tabella: new TabellaCustomClass(),
      // tabella_query_editor: {},
      // Modal
      overlay: false,
      sezione_attiva: 1,
      from_adapter: false,
      from_adapter_list: true,
      save_table_snack: false,
      // Array
      lista_tabelle: [],
      template: null,
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    creaTabella() {
      this.from_adapter = true;
      this.sezione_attiva = 2;
    },
    clickIndietro() {
      this.sezione_attiva = 1;
      this.tabella = new TabellaCustomClass();
      console.log("Sezione attiva: ", this.sezione_attiva);
    },
    getTabella() {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          // tipologia: ["Avanzamento", "Avanzamento-dettaglio", "Avanzamento-fermi"],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        console.log("ORA?");
        this.lista_tabelle = res.data.result.query;

        this.lista_tabelle.forEach((t) => {
          if (!t.params) {
            console.log("entra no params");
            t.params = [];
          }
          t.query = t.query1;
        });
      });
    },
    goBack() {
      (this.tabella = new TabellaCustomClass()), this.$router.push("/home");
    },
    goToModificaTabella(item) {
      this.from_adapter = true;
      this.sezione_attiva = 2;
      this.tabella = item;
      this.tabella.query = this.tabella.query1;
      console.log("clickPencil:", this.tabella);
      // this.tabella_query_editor.colonne = tabella.colonne;
      // this.tabella_query_editor.query = tabella.query[0].query;
      // this.tabella_query_editor.parametri = [];
      // console.log("tabella query nel padre", this.tabella_query_editor);
    },
    saveTable(arg) {
      console.log("arg in emit",arg);
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          // tipologia: ["Avanzamento", "Avanzamento-dettaglio", "Avanzamento-fermi"],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        console.log("res emit",res);
        this.lista_tabelle = res.data.result.query;
        // let last_mod;

        // let arr_tmp = [];
        // if (arg == "new") {
        //   console.log("entra new");
        //   arr_tmp = this.lista_tabelle.sort((a, b) => {
        //     return new Date(a.date_ins) - new Date(b.date_ins);
        //   });
        // } else if (arg == "old") {
        //   console.log("entra old");
        //   arr_tmp = this.lista_tabelle.sort((a, b) => {
        //     return new Date(a.date_mod) - new Date(b.date_mod);
        //   });
        // }

        // last_mod = arr_tmp[arr_tmp.length -1];
        

        //  console.log(last_mod);

        //  this.save_table_snack = true;

        //   this.goToModificaTabella(last_mod);
      });
    },
    setTabella(item) {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setquerydettaglio",
          token: localStorage.user_token,
          tabella: [item],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.getTabella();
           this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Salvataggio andato a buon fine."
          );
        })
        .catch(() => {
           this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getTabella();
  },
};
</script>
<style scoped>
</style>